import { useMutation } from '@tanstack/react-query';
import { BidRequestData, createBidRequest } from 'components/RfxDrawers/api';

export const useCreateNewRfx = () => {

  return useMutation({
    mutationFn: async (payload: BidRequestData) => {
      const response = await createBidRequest(payload);
      return response.data;
    }
  });
};
